module.exports = __webpack_public_path__ + "static/media/DsFolder.30bd3605.svg";